import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el producto?',
    a: 'Lo recibís inmediatamente luego del pago, por email, junto con un enlace de descarga.'
  }, {
    q: '¿Necesito conocimientos especiales?',
    a: 'No. Todo está explicado paso a paso, pensado para familias sin experiencia previa.'
  }, {
    q: '¿Puedo imprimirlo las veces que quiera?',
    a: 'Sí. El material es reutilizable y podés imprimirlo cuantas veces necesites.'
  }, {
    q: '¿Funciona si tengo poco tiempo?',
    a: 'Sí. Justamente fue pensado para familias ocupadas: la mayoría de las actividades se preparan en menos de 5 minutos.'
  }, {
    q: '¿Necesito materiales especiales?',
    a: 'No. La mayoría de las actividades usan cosas simples que ya tenés en casa.'
  }, {
    q: '¿Para qué edad es adecuado?',
    a: 'Está pensado para niños de 0 a 5 años, con propuestas adaptadas a cada etapa.'
  }, {
    q: '¿Puedo usarlo desde el celular?',
    a: 'Sí. Funciona en celular, tablet y computadora. No necesitás instalar nada.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-white px-5 py-10 sm:py-12" data-id="element-54">
      <div className="max-w-2xl mx-auto" data-id="element-55">
        <div className="text-center mb-8" data-id="element-56">
          <p className="text-xs uppercase tracking-wider text-brand-green-600 font-bold mb-3" data-id="element-57">
            FAQ
          </p>
          <h2 className="font-extrabold text-3xl sm:text-4xl text-brand-ink leading-tight tracking-tight" data-id="element-58">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-2" data-id="element-59">
          {faqs.map((faq, idx) => <div key={idx} className="bg-slate-50/80 rounded-2xl overflow-hidden border border-slate-100" data-id="element-60">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between gap-4 p-5 text-left hover:bg-slate-100/60 transition-colors" aria-expanded={openIndex === idx} data-id="element-61">
                <span className="font-semibold text-brand-ink" data-id="element-62">{faq.q}</span>
                <PlusIcon className={`w-5 h-5 text-slate-400 transition-transform duration-300 shrink-0 ${openIndex === idx ? 'rotate-45' : ''}`} data-id="element-63" />
              </button>
              <AnimatePresence initial={false} data-id="element-64">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25,
              ease: 'easeOut'
            }} className="overflow-hidden" data-id="element-65">
                    <p className="px-5 pb-5 text-slate-600 leading-relaxed" data-id="element-66">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}